<script lang="ts" setup>
import { AppCard } from '#core/components/';
import { computed, ref } from 'vue';
import EmailForm from './EmailForm.vue';
import ResetPasswordForm from './ResetPasswordForm.vue';
import VerifyForm from './VerifyForm.vue';

const formType = ref<'email' | 'otp' | 'password'>('email');

const username = ref();
const token = ref();

const parsedTitle = computed((): string => {
  const titles = {
    email: 'Forgot Password',
    otp: 'Verification Code',
    password: 'Reset Password',
  };

  return titles[formType.value];
});

const parsedSubtitle = computed((): string => {
  const subtitles = {
    email: "Enter your email and we'll send you a password reset link",
    otp: `Enter the code sent to ${username.value}`,
    password: 'Enter your new password',
  };

  return subtitles[formType.value];
});
</script>

<template>
  <AppCard :title="parsedTitle" :subtitle="parsedSubtitle">
    <EmailForm
      v-if="formType === 'email'"
      data-testid="email-form"
      @next="
        formType = 'otp';
        username = $event;
      "
    />

    <VerifyForm
      v-if="formType === 'otp'"
      :username="username"
      data-testid="verify-form"
      @next="
        formType = 'password';
        token = $event;
      "
    />

    <ResetPasswordForm
      v-if="formType === 'password'"
      data-testid="reset-password-form"
      :username="username"
      :token="token"
    />
  </AppCard>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 132px;
}
</style>
